import React from 'react'
import { Typography, Box } from '@mui/material'

export const QuestionValidationTooltip = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null
  }

  return (
    <div>
      <Typography>This content has incomplete question blocks.</Typography>
      <Typography>Please fix the following issues:</Typography>
      <Box
        component='ul'
        sx={{ margin: 0, padding: '8px' }}
        data-test='content-question-validation-list'
      >
        {errors.map((error, index) => (
          <Box
            key={index}
            component='li'
            data-test='content-question-validation-list-item'
          >
            <Typography>{error}</Typography>
          </Box>
        ))}
      </Box>
    </div>
  )
}
